
import React, { useState, useRef } from 'react';

// Reusable Perspective Hover Wrapper Component
const PerspectiveHoverWrapper = ({ 
  children, 
  maxRotation = 15, 
  glowEffect = false, 
  className = "",
  style = {},
  perspective = 1000,
  transitionDuration = 300,
  ...rest
}) => {
  const [cardState, setCardState] = useState({
    rotateX: 0,
    rotateY: 0,
    isHovered: false
  });
  
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;

    const card = cardRef.current;
    const rect = card.getBoundingClientRect();

    // Get mouse position relative to card center
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Calculate center point
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    // Calculate rotation values (normalize to -1 to 1, then multiply by max rotation)
    const rotX = ((y - centerY) / centerY) * -maxRotation; // Invert Y axis for natural rotation
    const rotY = ((x - centerX) / centerX) * maxRotation;

    setCardState({
      rotateX: rotX,
      rotateY: rotY,
      isHovered: true
    });
  };

  const handleMouseEnter = () => {
    setCardState(prev => ({
      ...prev,
      isHovered: true
    }));
  };

  const handleMouseLeave = () => {
    setCardState({
      rotateX: 0,
      rotateY: 0,
      isHovered: false
    });
  };

  return (
    <div 
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`transition-all ease-out ${className}`}
      style={{
        transform: `perspective(${perspective}px) rotateX(${cardState.rotateX}deg) rotateY(${cardState.rotateY}deg)`,
        transformStyle: 'preserve-3d',
        transitionDuration: `${transitionDuration}ms`,
        ...style
      }}
      {...rest}
    >
      {/* Optional glow effect */}
      {glowEffect && (
        <div 
          className="absolute inset-0 opacity-20 transition-opacity duration-300 pointer-events-none rounded-inherit z-10"
          style={{
            opacity: cardState.isHovered ? 0.2 : 0,
            background: cardState.isHovered ? 
              `radial-gradient(circle at ${((cardState.rotateY + maxRotation) / (maxRotation * 2)) * 100}% ${((cardState.rotateX + maxRotation) / (maxRotation * 2)) * 100}%, rgba(255,255,255,0.3) 0%, transparent 50%)` : 
              'transparent',
          }}
        />
      )}
      
      {children}
    </div>
  );
};

export default PerspectiveHoverWrapper;